import React from "react";
import {
  Box,
  Text,
  Icon,
  Button,
  HStack,
  VStack,
  Divider,
  useColorMode,
  Heading,
} from "@chakra-ui/react";
import travelTrackerImg from "../../assets/images/travel-tracker.png";
import { useHistory } from "react-router-dom";
import Translate from "../../components/LanguageTranslation/Translate";

const TemporaryScreen = ({ fetchTrips }) => {
  const { colorMode } = useColorMode();
  const history = useHistory();

  const redirectToChat = () => {
    history.push("/ai-travel-planner/chat");
  };

  const redirectToBucketList = () => {
    history.push("/ai-travel-planner/bucket-list");
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      w="100%"
      h="100%"
      bg={colorMode === "dark" ? "gray.800" : "white"}
    >
      <Box textAlign="center" mb={4}>
        <img
          src={travelTrackerImg}
          alt="Travel Tracker"
          style={{ width: "auto", height: 80, objectFit: "contain", margin: "0 auto" }}
        />
        {/* Main Heading */}
        <Text fontSize="2xl" fontWeight="bold" mt={2} color="#1A202C" mb={0}>
          Get Ready for Your{" "}
          <Text as="span" color="#286328">
            Green & Wild
          </Text>{" "}
          Community!
        </Text>

        <VStack mt={2} spacing={0}>
          <Text
            fontSize="md"
            color={colorMode === "dark" ? "#1A202C" : "#1A202C"}
            mb={0}
          >
            <Translate text=" We're putting the finishing touches on our Travel Feed." />
          </Text>
          <Text
            fontSize="md"
            color={colorMode === "dark" ? "#1A202C" : "#1A202C"}
            mb={0}
          >
            <Translate text="Stay tuned for a quick launch!" />
          </Text>
        </VStack>

        <HStack alignContent="center" justifyContent="center">
          <Button
            mt={6}
            bg="#286328"
            color="white"
            _hover="none"
            borderRadius="lg"
            onClick={redirectToChat}
          >
            <Translate text="Plan a trip" />
          </Button>
          <Divider
            orientation="vertical"
            h="40px"
            borderColor={colorMode === "dark" ? "black" : "black"}
            mt={6}
            mb={0}
          />
          <Button
            mt={6}
            bg="#286328"
            color="white"
            _hover="none"
            borderRadius="lg"
            onClick={redirectToBucketList}
          >
            <Translate text="Bucket list" />
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};

export default TemporaryScreen;
